export enum Role {
    PUBLIC = 'PUBLIC',
    ADMIN = 'ADMIN',
}

